
    import ReflectionDemonstration from './ReflectionDemonstration.svelte'
    import RootSystem from './RootSystem.svelte'
    import { groups } from 'lielib'

    new ReflectionDemonstration({target: document.getElementById('ReflectionDemonstration')})

    // Render each RootSystem just before the <RootSystem> element, then remove <RootSystem>.
    document.querySelectorAll('RootSystem').forEach(elt => {
        new RootSystem({target: elt.parentElement, anchor: elt, props: {
            width: elt.getAttribute('width'),
            height: elt.getAttribute('height'),
            scale: elt.getAttribute('scale'),
            datum: groups.simplyConn(groups.rootSystems[elt.getAttribute('datum')]),
        }})
        elt.remove()
    })
